import { Col, Input, Row, Table, Select, Button, Popconfirm, Switch, notification, Spin } from "antd";
import { useEffect, useState } from "react";
import { UploadOutlined, EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { setHeaderName } from "../../../../services/SetHeaderName";
import { Link } from "react-router-dom";
import { editIngredientsApi, listOfIngredientsApi, updateIngredientsApi } from "../../../../config/Api";
import { API_ERR_MESSAGE } from "../../../../config/constant";
import { read, utils, write } from 'xlsx';

export const IngredientsList = () => {
    const { Option } = Select;

    const data = [
        {
            id: '1001',
            name: 'Bajra',
            english_name: 'pearl millet',
            status: false,
        },
        {
            id: '1002',
            name: 'Ragi',
            english_name: 'Finger Millet',
            status: true,
        },
        {
            id: '1003',
            name: 'sarso ke patte',
            english_name: 'mustard leaves',
            status: true,
        },
        {
            id: '1004',
            name: 'capsicum',
            english_name: 'bell pepper',
            status: false,
        },
        {
            id: '1005',
            name: 'blackcaps',
            english_name: 'black berry',
            status: true,
        },
    ];

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [ingredientsList, setIngredientsList] = useState([]);
    const [clientData, setClientData] = useState();
    const [IngredientData, setIngredientData] = useState()
    const [isActive, setIsActive] = useState(false)
    const [loading, setLoading] = useState(false)

    // get the list of all Ingredients List and its data 
    //==========================================
    const getListOfIngredients = () => {
        setLoading(true)

        listOfIngredientsApi()
            .then((res) => {
                if (res.status === 200) {
                    if (res.data.data && res.data.data?.length > 0) {

                        setIngredientsList(res.data.data);
                        setDataSource(res.data.data)
                        setDisplayData(res.data.data)
                    }

                }
                setLoading(false)
            })
            .catch((err) => {
                console.log("err in list", err);
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    useEffect(() => {
        getListOfIngredients()
        setHeaderName("Clients List")
    }, []);

    // filter Ingredient
    const filterIngredient = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            console.log(dataSource);
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1 ||
                    element.ingredientEnglishName.toUpperCase().indexOf(data.toUpperCase()) !== -1
                ) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // filter data according to user search input 
    useEffect(() => {
        filterIngredient(IngredientData);
    }, [IngredientData]);

    // update status of ingredient data
    const onChange = (checked, data) => {
        // get that particular record data from its id and update status 
        editIngredientsApi(data.id)
            .then((res) => {
                if (res.status === 200) {
                    let updatedData = res.data.data
                    updatedData.status = checked

                    console.log("updatedData", updatedData);
                    // call update api to change ingredient status
                    updateIngredientsApi(updatedData.id, updatedData)
                        .then((res) => {
                            if (res.status == 200) {
                                notification.success({
                                    message: "Ingredient Update successfully",
                                });
                                getListOfIngredients()
                            }
                        })
                        .catch((err) => {
                            notification.error({
                                message: API_ERR_MESSAGE,
                            });
                        });
                }
            })
            .catch((err) => {
                // notification.error({
                //     message: API_ERR_MESSAGE,
                // });
                console.log(err);
            });

    };


    const exportData = () => {
        // Sample array data
        const dataArray = []

        if (displayData && displayData.length > 0) {
            // displayData.forEach(values => {
            //     if (values.form_wise_macros_micros && values.form_wise_macros_micros.length > 0) {
            //         values.form_wise_macros_micros.forEach(macrodRecord => {
            //             if (macrodRecord.ingredient_macros_micros && macrodRecord.ingredient_macros_micros.length > 0) {
            //                 macrodRecord.ingredient_macros_micros.forEach((recordValues, index) => {
            //                     dataArray.push({
            //                         "NAME": index == 0 ? values.name : '',
            //                         "ENGLISH NAME": index == 0 ? values.ingredientEnglishName : '',
            //                         "DESCRIPTION": index == 0 ? values.ingredient_description : '',
            //                         // "TYPE": recordValues.type,

            //                         "Moisture": recordValues?.macros_micros?.name == "B3 Niacin" ? recordValues.per_hundred_gram : 0,
            //                         "Dietary Fiber": recordValues?.macros_micros?.name == "Dietary Fiber" ? recordValues.per_hundred_gram : 0,
            //                         "Carbohydrate": recordValues?.macros_micros?.name == "Carbohydrate" ? recordValues.per_hundred_gram : 0,
            //                         "Total Fat": recordValues?.macros_micros?.name == "Total Fat" ? recordValues.per_hundred_gram : 0,
            //                         "Protein": recordValues?.macros_micros?.name == "Protein" ? recordValues.per_hundred_gram : 0,
            //                         "Energy": recordValues?.macros_micros?.name == "Energy" ? recordValues.per_hundred_gram : 0,

            //                         "B3 Niacin": recordValues?.macros_micros?.name == "B3 Niacin" ? recordValues.per_hundred_gram : 0,
            //                         "Magnesium": recordValues?.macros_micros?.name == "Magnesium" ? recordValues.per_hundred_gram : 0,
            //                         "Manganese": recordValues?.macros_micros?.name == "Manganese" ? recordValues.per_hundred_gram : 0,
            //                         "phosphorus": recordValues?.macros_micros?.name == "phosphorus" ? recordValues.per_hundred_gram : 0,
            //                         "Zinc (Zn)": recordValues?.macros_micros?.name == "Zinc (Zn)" ? recordValues.per_hundred_gram : 0,
            //                         "Sodium (Na)": recordValues?.macros_micros?.name == "Sodium (Na)" ? recordValues.per_hundred_gram : 0,
            //                         "Potassium (K)": recordValues?.macros_micros?.name == "Potassium (K)" ? recordValues.per_hundred_gram : 0,
            //                         "Iron (Fe)": recordValues?.macros_micros?.name == "Iron (Fe)" ? recordValues.per_hundred_gram : 0,
            //                         "Calcium (Ca)": recordValues?.macros_micros?.name == "Calcium (Ca)" ? recordValues.per_hundred_gram : 0,
            //                         "Folates (B9)": recordValues?.macros_micros?.name == "Folates (B9)" ? recordValues.per_hundred_gram : 0,
            //                         "Total B6": recordValues?.macros_micros?.name == "Total B6" ? recordValues.per_hundred_gram : 0,
            //                         "Riboflavin (B2)": recordValues?.macros_micros?.name == "Riboflavin (B2)" ? recordValues.per_hundred_gram : 0,
            //                         "Thiamine (B1)": recordValues?.macros_micros?.name == "Thiamine (B1)" ? recordValues.per_hundred_gram : 0,
            //                         "Vitamin K": recordValues?.macros_micros?.name == "Vitamin K" ? recordValues.per_hundred_gram : 0,
            //                         "α -Tocopherol equivalent (E)": recordValues?.macros_micros?.name == "α -Tocopherol equivalent (E)" ? recordValues.per_hundred_gram : 0,
            //                         "Vitamin D": recordValues?.macros_micros?.name == "Vitamin D" ? recordValues.per_hundred_gram : 0,
            //                         "Ascorbic acids (C)": recordValues?.macros_micros?.name == "Ascorbic acids (C)" ? recordValues.per_hundred_gram : 0,
            //                         "Retinol (Vit A)": recordValues?.macros_micros?.name == "Retinol (Vit A)" ? recordValues.per_hundred_gram : 0,

            //                         // "MACROS/MICROS NAME": recordValues?.macros_micros?.name,
            //                         // "VALUES": recordValues.per_hundred_gram,
            //                         "MACROS/MICROS ID": recordValues.macros_micros_id,
            //                     });
            //                 });
            //             }
            //         });
            //     }
            // });
            displayData.forEach(values => {
                if (values.form_wise_macros_micros && values.form_wise_macros_micros.length > 0) {
                    values.form_wise_macros_micros.forEach(macrodRecord => {
                        // if (macrodRecord.ingredient_macros_micros && macrodRecord.ingredient_macros_micros.length > 0) {
                        // macrodRecord.ingredient_macros_micros.forEach((recordValues, index) => {
                        const findName = (macros_micros_name) => {
                            let macros_record =
                                macrodRecord?.ingredient_macros_micros?.find(record =>
                                    record?.macros_micros?.name == macros_micros_name)
                            return macros_record ? macros_record?.per_hundred_gram : 0
                        }
                        dataArray.push({
                            "NAME": values?.name,
                            "ENGLISH NAME": values?.ingredientEnglishName,
                            "DESCRIPTION": values?.ingredient_description,
                            // "TYPE": recordValues.type,

                            // working  13-3-24 
                            // =========
                            // "Moisture": findName("Moisture"),
                            // "Dietary Fiber": findName("Dietary Fiber"),
                            // "Carbohydrate": findName("Carbohydrate"),
                            // "Total Fat": findName("Total Fat"),
                            // "Protien": findName("Protien"),
                            // "Energy": findName("Energy"),

                            // // lateast code after micros change
                            // "Sodium (Na)": findName("Sodium (Na)"),
                            // "Vit B1 (Thiamine)": findName("Vit B1 (Thiamine)"),
                            // "Vit B2 (Riboflavin)": findName("Vit B2 (Riboflavin) "),
                            // "Vit B3 (9Niacin)": findName("Vit B3 (9Niacin)"),
                            // "choline": findName("choline"),
                            // "Vit B6 (Pyridoxine)": findName("Vit B6 (Pyridoxine)"),
                            // "Vit B7 (Biotin)": findName("Vit B7 (Biotin)"),
                            // "Vit B9 (free folate)": findName("Vit B9 (free folate)"),
                            // "Vit B9 (Folate)": findName("Vit B9 (Folate) "),
                            // "Vit B12 (Cobalamin)": findName("Vit B12 (Cobalamin)"),
                            // "Vit C": findName("Vit C"),
                            // "Vit A (beta carotene)": findName("Vit A (beta carotene)"),
                            // "Vit A (Retinol)": findName("Vit A (Retinol)"),
                            // "Vitamin D": findName("Vitamin D"),
                            // "Vit E (α -Tocopherol equivalent )": findName("Vit E (α -Tocopherol equivalent )"),
                            // "Vitamin K": findName("Vitamin K"),
                            // "Calcium (Ca)": findName("Calcium (Ca)"),
                            // "phosphorus": findName("phosphorus"),
                            // "Iron (Fe)": findName("Iron (Fe)"),
                            // "Magnesium": findName("Magnesium"),
                            // "Potassium (K)": findName("Potassium (K)"),
                            // "Copper(cu)": findName("Copper(cu)"),
                            // "Manganese": findName("Manganese"),
                            // "Molybdenum": findName("Molybdenum"),
                            // "Zinc (Zn)": findName("Zinc (Zn)"),
                            // "Chromium": findName("Chromium"),
                            // "Ascorbic acids (C)": findName("Ascorbic acids (C)"),
                            // // last one macros
                            // "Visible Fat": findName("Visible Fat"),

                            // now   macros-7 micros- 27  total -34
                            "Energy": findName("Energy"),
                            "Carbohydrate": findName("Carbohydrate"),
                            "Protien": findName("Protien"),
                            "Total Fat": findName("Total Fat"),
                            "Visible Fat": findName("Visible Fat"),
                            // "Dietary Fiber": findName("Dietary Fiber"),
                            "Crude Fiber": findName("Crude Fiber"),
                            "Moisture": findName("Moisture"),

                            // lateast code after micros change
                            "Sodium (Na)": findName("Sodium (Na)"),
                            "Vit B1 (Thiamine)": findName("Vit B1 (Thiamine)"),
                            "Vit B2 (Riboflavin)": findName("Vit B2 (Riboflavin) "),
                            "Vit B3 (9Niacin)": findName("Vit B3 (9Niacin)"),
                            "choline": findName("choline"),
                            "Vit B6 (Pyridoxine)": findName("Vit B6 (Pyridoxine)"),
                            "Vit B7 (Biotin)": findName("Vit B7 (Biotin)"),
                            "Vit B9 (free folate)": findName("Vit B9 (free folate)"),
                            "Vit B9 (Folate)": findName("Vit B9 (Folate) "),
                            "Vit B12 (Cobalamin)": findName("Vit B12 (Cobalamin)"),
                            "Vit C": findName("Vit C"),
                            "Vit A (beta carotene)": findName("Vit A (beta carotene)"),
                            "Vit A (Retinol)": findName("Vit A (Retinol)"),
                            "Vitamin D": findName("Vitamin D"),
                            "Vit E (α -Tocopherol equivalent )": findName("Vit E (α -Tocopherol equivalent )"),
                            "Vitamin K": findName("Vitamin K"),
                            "Calcium (Ca)": findName("Calcium (Ca)"),
                            "phosphorus": findName("phosphorus"),
                            "Iron (Fe)": findName("Iron (Fe)"),
                            "Magnesium": findName("Magnesium"),
                            "Potassium (K)": findName("Potassium (K)"),
                            "Copper(cu)": findName("Copper(cu)"),
                            "Manganese": findName("Manganese"),
                            "Molybdenum": findName("Molybdenum"),
                            "Zinc (Zn)": findName("Zinc (Zn)"),
                            "Chromium": findName("Chromium"),
                            "Ascorbic acids (C)": findName("Ascorbic acids (C)"),


                            // "MACROS/MICROS NAME": recordValues?.macros_micros?.name,
                            // "VALUES": recordValues.per_hundred_gram,
                            // "MACROS/MICROS ID": recordValues.macros_micros_id,
                        });
                        // });
                        // }
                    });
                }
            });
        }
        console.log("dataArray[0]", dataArray[0]);

        // Extract headers from the first object in the array
        const headers = Object.keys(dataArray[0]);

        // Map the array of objects to a 2D array
        const dataMatrix = dataArray.map(obj => headers.map(header => obj[header]));

        // Create a new workbook
        const wb = utils.book_new();

        // Add a worksheet to the workbook
        const ws = utils.aoa_to_sheet([headers, ...dataMatrix]);

        // Add the worksheet to the workbook
        utils.book_append_sheet(wb, ws, 'Sheet1');

        // Check if the sheet contains any data
        const range = ws['!ref'];

        if (range) {
            // Generate a binary representation of the XLSX file
            const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

            // Create a Blob from the binary data
            const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

            // Create a download link and trigger a click event to download the file
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'INGREDIENTS.xlsx';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.error('The sheet does not contain any data.');
        }
    };


    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
            // render: (text, record) => <Link to={{ pathname: `/patient-detail/${record.id}` }}>{record.name}</Link>,
        },
        {
            title: 'English Name',
            dataIndex: 'ingredientEnglishName',
            key: 'ingredientEnglishName',
        },

        // {
        //     title: 'Status',
        //     dataIndex: 'status',
        //     key: 'status',
        //     render: (text, data) => <>
        //         <p style={{ color: data.status ? "green" : "red" }}>{data.status ? "Active" : "Deactivated"} </p>
        //     </>,
        //     filters: [
        //         { text: "Activate", value: true },
        //         { text: "Deactivated", value: false },
        //     ],
        //     onFilter: (value, record) => record.phenoType == value,
        // },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Link to={{ pathname: `/edit-ingredient/${record.id}` }}>
                        <Button icon={<EditOutlined />} className="me-2" />
                    </Link>
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="ClientsList">
                <Row className="mb-2">
                    <Col xl={5} className="align-self-center">
                        <Link to={{ pathname: '/add-ingredient' }} >
                            <Button htmlType="submit" className="submit-button bg-primary text-white my-2 border-0 rounded ms-2 " icon={<PlusOutlined style={{ fontSize: "1.2rem" }} />}
                            // onClick={() => setIsModalVisible(true)}
                            >
                                Add New Ingredients
                            </Button>
                        </Link>
                    </Col>
                    <Col xl={3} className="align-self-center">
                        <Button
                            className="ml-3"
                            disabled={(displayData && displayData?.length > 0) ? false : true}
                            icon={<UploadOutlined />}
                            onClick={exportData}>
                            Export Excel
                        </Button>
                        {/* <Button htmlType="submit" className="submit-button  border-0 rounded ms-2 " onClick={() => setIsModalVisible(true)}>
                            Add
                        </Button> */}
                    </Col>
                    <Col xl={10} className="text-end align-self-center pe-4">
                        <h6 className="mb-0">Total Ingredients:  {displayData.length > 0 ? displayData.length : 0}   </h6>
                    </Col>
                    <Col xl={6} className="align-self-center pe-2">
                        <Input.Search placeholder="Search Ingredients"
                            // onChange={e => {
                            //     let currValue = e.target.value;
                            //     let filteredData = data.filter(entry =>
                            //         entry.name.toLowerCase().includes(currValue) ||
                            //         entry.english_name.toLowerCase().includes(currValue));
                            //     setDataSource(filteredData);
                            // }}
                            onChange={(e) => { filterIngredient(e.target.value); setIngredientData(e.target.value) }}
                            className="p-2" />
                    </Col>
                </Row>
                <Spin spinning={loading} className="spinner-code">
                    <Row>
                        <Col span={24} className="">
                            <Table
                                pagination={{
                                    pageSizeOptions: ['10', '20', '50', '100'], // Options for the number of items per page
                                    showSizeChanger: true, // Enable the page size changer
                                    defaultPageSize: 10, // Default number of items per page
                                    // showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`, // Display total items
                                }}
                                columns={columns}
                                dataSource={displayData}
                                rowKey="id"
                                // pagination={false}
                                scroll={{ x: "max-content" }}
                                className="w-100"
                            />
                        </Col>
                    </Row>
                </Spin>
            </div>
        </>
    )
}
